import * as React from 'react';
import SystemAlerts from 'src/component/SystemAlerts';
import Constants from 'src/support/Constants';

const AlertHeader = (props) => {
    const { alertTypes: { PCN } } = Constants
    const alertType = props.selectedTab || PCN
    
    return (
        <>
            <div className="account-heading additional-word-wrap">
                <h1>
                    <i className="fa fa-envelope me-2 mb-0"></i>
                    {alertType !== undefined ? alertType : 'PCN'} Alerts
                </h1>
            </div>
            <SystemAlerts />
        </>
    );
}

export default AlertHeader;